import React, { useContext, useState } from "react";
import styled from "styled-components";
import APIService from "../../services/APIService";
import { AuthUserContext } from "../../context/AuthUserContext";

const CardPaymentLink = ({ amount, email, checkbox }) => {
  const [loading, setLoading] = useState(false);
  const { authTokens } = useContext(AuthUserContext);

  const handlePayment = async () => {
    setLoading(true);

    try {
      console.log("Creating Mollie payment link...");

      // Kreiranje plaćanja i dobijanje linka
      const description = "Purchase from Snusco-AT";
      const paymentUrl = await APIService.CreatePayment(
        { amount, email, description },
        authTokens.access
      );

      window.location.href = paymentUrl; // Preusmeravanje na Mollie checkout
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <PaymentContainer>
        <div>Amount: €{amount}</div>
        <SubmitButton onClick={handlePayment} disabled={loading || !checkbox}>
          {loading ? "Processing..." : "Pay Now"}
        </SubmitButton>
      </PaymentContainer>
    </Wrapper>
  );
};

export default CardPaymentLink;

// Styled Components
const Wrapper = styled.div`
  width: 100%;
`;

const PaymentContainer = styled.div`
  width: 100%;
`;

const SubmitButton = styled.button`
  width: 100%;
  margin: 14px 0;

  opacity: ${(props) =>
    props.disabled ? 0.5 : 1}; /* Stilizacija za disabled stanje */

  &:disabled {
    cursor: not-allowed; /* Prikazuje da je dugme onemogućeno */
  }
`;
